import type { ITask, ITaskInput } from '@torim-app/types';
import { useDrawer } from '@torim-app/shared-components';
import TaskEditor from './TaskEditor.vue';

/** Opens the task sheet (mobile bottom sheet / desktop side drawer) to create or edit a task. */
export function useTaskEditor() {
  const { openDrawer } = useDrawer();

  const openTaskEditor = (opts: {
    task?: ITask;
    defaults?: Partial<ITaskInput> & { customerName?: string };
    lockCustomer?: boolean;
    onSaved?: (task: ITask) => void;
  } = {}) => {
    openDrawer(TaskEditor, {
      task: opts.task,
      defaults: opts.defaults,
      lockCustomer: opts.lockCustomer,
      onSaved: opts.onSaved,
    }, {
      title: opts.task ? 'עריכת משימה' : 'משימה חדשה',
      noPadding: true,
      full: false,
    });
  };

  return { openTaskEditor };
}
